<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :exclude="uncachedComponent">
        <router-view :key="key" v-if="!isFrame"/>
      </keep-alive>
    </transition>
    <component
       v-for="item in activeIframes"
       :key="item.name"
       :is="item.comp"
       :viewUrl="item.viewUrl"
       v-show="$route.path === item.path"
    ></component>
	<!-- 转接弹窗 -->
	<TransformPanle/>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Bus from '@/utils/bus';
import outlink from "@/views/outlink";
import TransformPanle from '@/views/im-channel/imService/panels/transform';

export default {
  name: 'AppMain',
  components: {
    outlink,
	TransformPanle
  },
  data() {
    return {
    iframes: [],
    componentsArr: [], // 含有iframe的页面
    isFrame: false,
    uncachedComponent: ['redirect','CallOut']
    }
},
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    },
    ...mapGetters([
        'permission_menus',
        ]),
    activeIframes(){
        return this.iframes.filter(iframe => iframe.isActive);
    },
  },
  watch: {
  $route() {
    this.isFrame = this.$route.path.indexOf("iframe") > -1;
   // 判断当前路由是否iframe页
   this.isOpenIframePage();
  }
 },
 created(){
    this.initIframe();
 },
    mounted() {
        // 关闭标签触发
        Bus.$on('removeCache', (name, view) => {
            this.removeCache(name, view);
            if(name == "closeSelectedTag"){
                this.closeIframe(view.path);
            }
        });
    },
    methods: {
        // 获取有keep-alive子节点的Vnode
        getVnode() {
            // 判断子集非空
            if (this.$children.length == 0) return false;
            let vnode;
            for (let item of this.$children) {
                // 如果data中有key则代表找到了keep-alive下面的子集，这个key就是router-view上的key
                if (item.$vnode.data.key && item.$vnode.parent !== undefined) {
                    vnode = item.$vnode;
                    break;
                }
            }
            return vnode ? vnode : false;
        },

        // 移除keep-alive缓存
        removeCache(name, view = {}) {
            let vnode = this.getVnode();
            if (!vnode) return false;
            let componentInstance = vnode.parent.componentInstance;
            // 这个key是用来获取前缀用来后面正则匹配用的
            let keyStart = vnode.key.split('/')[0];
            let thisKey = `${keyStart}${view.fullPath}`;
            let regKey = `${keyStart}${view.path}`;

            this[name]({ componentInstance, thisKey, regKey });
        },

        // 移除其他
        closeOthersTags({ componentInstance, thisKey }) {
            Object.keys(componentInstance.cache).forEach((key, index) => {
                if (key != thisKey) {
                    // 1 销毁实例(这里存在多个key指向一个缓存的情况可能前面一个已经清除掉了所有要加判断)
                    if (componentInstance.cache[key]) {
                        componentInstance.cache[key].componentInstance.$destroy();
                    }
                    // 2 删除缓存
                    delete componentInstance.cache[key];
                    // 3 移除key中对应的key
                    componentInstance.keys.splice(index, 1);
                }
            });
        },

        // 移除所有缓存
        closeAllTags({ componentInstance }) {
            // 1 销毁实例
            Object.keys(componentInstance.cache).forEach(key => {
                if (componentInstance.cache[key]) {
                    componentInstance.cache[key].componentInstance.$destroy();
                }
            });
            // 2 删除缓存
            componentInstance.cache = {};
            // 3 移除key中对应的key
            componentInstance.keys = [];
        },

        // 移除单个缓存
        closeSelectedTag({ componentInstance, regKey }) {
            let reg = new RegExp(`^${regKey}`);
            Object.keys(componentInstance.cache).forEach((key, i) => {
                if (reg.test(key)) {
                    // 1 销毁实例
                    if (componentInstance.cache[key]) {
                        componentInstance.cache[key].componentInstance.$destroy();
                    }
                    // 2 删除缓存
                    delete componentInstance.cache[key];
                    // 3 移除key中对应的key
                    componentInstance.keys.splice(i, 1);
                }
            });
        },

        // 如果iframes中有项的path为path将该项的isActive置为false;
        closeIframe(path){
            let iframe = this.iframes.find(item=>{
                return item.path == path
            });
            if(iframe){
                iframe.isActive = false;
            }
        },
        // 根据当前路由设置isActive
        isOpenIframePage() {
            const target = this.iframes.find(item => {
                return item.path === this.$route.path
            });
            if (target && !target.hasOpen) {
                target.isActive = true;
            }

        },
        initIframe(){
            let iframes = [];
            function pickIframe(nodes){
                for(let node of nodes){
                    if(node.menuUrl.indexOf("/iframe")>-1){
                        iframes.push({
                            name: node.menuName,
                            comp: outlink,
                            path: node.menuUrl,
                            viewUrl: node.viewUrl,
                            hasOpen: false, // 是否打开过，默认false
                            isActive: false
                        })
                    }
                    pickIframe(node.nodes);
                }
            }
            pickIframe(this.permission_menus);
            this.iframes = iframes;
        }
    },
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 60= navbar  60  */
  height: calc(100vh - 60px - 34px);
  // height: calc(100vh - 60px);
  width: 100%;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}

.fixed-header+.app-main {
  padding-top: 60px;
}

.hasTagsView {
  .app-main {
    /* 94 = navbar + tags-view = 60 + 34 */
    min-height: calc(100vh - 94px);
    // height: calc(100vh - 94px);
  }

  .fixed-header+.app-main {
    padding-top: 94px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
